//purchasedapp_reducer.js
const initial_state = {
  purchasedApps: [],
};

const purchasedAppReducer = (state = initial_state, action) => {
  switch (action.type) {
    case "GET_PURCHASED_APPS":
      return {
        ...state,
        purchasedApps: action.purchasedApps,
      };

    case "CLEAR_PURCHASED_APPS":
      return {
        ...state,
        purchasedApps: [],
      };

    default:
      return state;
  }
};

export default purchasedAppReducer;
